<template>
    <div>
        <Wp_nav_bar v-if="!$common.gloabl_wx_mini_user_info || !$common.gloabl_wx_mini_user_info.id"
                    :title="page_title">
        </Wp_nav_bar>

        <div v-if="page_tag">
            <Wp_access_count :page-tag="page_tag"></Wp_access_count>
        </div>

        <div style="padding: 15px 10px 5px 10px">
            <Wp_pull_list :all-params="all_params"
                     :url="url"
                     :page-size="page_size"
                     :data-type="2"
                     @onLoad="onLoad"
            >
                <div v-for="(item, index) in action_list" v-bind:key="index">

                    <div v-if="act_type === '1'"><!--公告-->
                        <van-cell :border="true"
                                  style="border: 1px dashed #EE0A24; border-radius: 5px; margin-bottom: 10px"
                                  :title="item.act_content"

                                  @click="showActionDetail(item)"
                        >
<!--                            <div slot="icon">-->
<!--                                <Wp_image v-if="item.act_share_img"  :url="item.act_share_img" :style="{width: ($common.screenWidth * 0.3) + 'px'}"/>-->
<!--                            </div>-->

                            <div slot="title" class="title_div_line_3" >
                                <span style="font-weight: bold; font-size: 17px">{{item.act_name}}</span><br>
                                <span>{{ "&nbsp;&nbsp;" + item.act_content}}</span>
                            </div>
                        </van-cell>
                    </div>
                    <div v-if="act_type === '2'"><!--领券-->
                        <van-cell :border="true"
                                  style="border: 1px dashed #EE0A24; border-radius: 5px; margin-bottom: 10px;"
                                  :title="item.act_name"
                                  title-class="title_div_line_1"
                                  size="large"
                                  @click="showActionDetail(item)"
                        >
                            <div slot="icon">
                                <Wp_image v-if="item.act_share_img" :url="item.act_share_img" style="width: 25px"/>
<!--                                <van-icon :name="item.act_share_img" size="25"></van-icon>-->
                            </div>

<!--                            <div slot="title" class="title_div_line_1" style="">-->
<!--                                {{item.act_name}}-->
<!--                            </div>-->
                        </van-cell>
                    </div>
                    <div v-if="act_type === '3'"><!--发圈-->
<!--                        <van-cell :border="true"-->
<!--                                  style="border: 1px dashed #EE0A24; border-radius: 5px; margin-bottom: 10px"-->
<!--                                  :title="item.act_content"-->

<!--                                  @click="showActionDetail(item)"-->
<!--                        >-->
<!--                            <div slot="icon">-->
<!--                                <Wp_image v-if="item.act_share_img"  :url="item.act_share_img" :style="{width: ($common.screenWidth * 0.3) + 'px'}"/>-->
<!--                            </div>-->

<!--                            <div slot="title" class="title_div_line_5" :style="{marginLeft: item.act_share_img ? '15px' : '0px'}">-->
<!--                                {{item.act_content}}-->
<!--                            </div>-->
<!--                        </van-cell>-->
                        <Wp_jd_share_with_link_model style="margin-bottom: 10px"
                                                     :share-data="item"

                        ></Wp_jd_share_with_link_model>
                    </div>
                    <div v-if="act_type === '4'"><!--插屏-->

                    </div>

                </div>

            </Wp_pull_list>
        </div>
    </div>
</template>

<script>
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    import Wp_image from "../custom/Wp_image";
    import Wp_pull_list from "../list/Wp_pull_list";
    import Wp_jd_share_with_link_model from "../custom/Wp_jd_share_with_link_model";
    import Wp_access_count from "../custom/Wp_access_count";
    export default {
        name: "Wp_jd_action_list",
        components: {Wp_access_count, Wp_jd_share_with_link_model, Wp_pull_list, Wp_image, Wp_nav_bar},
        data(){
            return{
                action_list:[],
                all_params:{},
                url:"",
                page_size: 20,

                act_type: "",

                page_title: "活动列表",

                page_tag: '',
            }
        },

        created(){
            this.initActionList();
        },

        methods:{

            initActionList(){

                this.act_type = this.$common.getUrlKey("act_type");

                if(this.act_type){
                    this.page_tag = "act_type_" + this.act_type;
                    if(this.act_type === "1"){
                        this.page_title = "公告";
                    }else if(this.act_type === "2"){
                        this.page_title = "领券";
                    }else if(this.act_type === "3"){
                        this.page_title = "发圈必备";
                    }
                }

                this.all_params = {
                    page: 1,
                    size: 20,
                    type: this.act_type
                };

                this.url = this.$common.get_action_list;

                // this.$getActionList(params, response=>{
                //     if(response && response.code === 200){
                //         if(response.data){
                //             this.action_list = response.data.list;
                //         }
                //     }
                // })
            },

            onLoad(list) {
                // 根据show获取可显示的数据
                let pop_temp = [];
                for(let i = 0; i < list.length; i++){
                    if(list[i].show === 0){
                        pop_temp.push(list[i]);
                    }
                }

                this.action_list = pop_temp;
            },

            showActionDetail(item){
                this.$common.static_action_info_datas = item;
                this.$router.push("action_info");
            },

            /**
             * 获取数据的类型
             * @param act_type
             * @return {*}
             */
            getType(act_type){
                if(act_type){
                    let type = "";
                    if(act_type.indexOf(",") !== -1){
                        type = act_type.substring(0, act_type.indexOf(","))
                    }else{
                        type = act_type;
                    }
                    return type;
                }else{
                    return "1";
                }
            }
        }
    }
</script>

<style scoped>
    .title_div_line_3{
        /*margin-top: 3px;*/
        font-size: 16px;
        /*font-weight: bold;*/
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
    }

    .title_div_line_5{
        /*margin-top: 3px;*/
        font-size: 17px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
    }

    .title_div_line_1{
        margin-left: 5px;
        font-size: 17px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
    }
</style>